import { Env } from "./Services/Env/Env";
import { EnvDetector } from "./Services/Env/EnvDetector";


export class AppConfig
{
    private CONFIG =
        {
            [Env.Local]: {
                storageUrl: "http://localhost/storageV5/src/",
                databaseName: "Specteam",
                ordersSystemUrl: "http://localhost:4999/#order/{id}"
            },
            [Env.Stage]: {
                storageUrl: "https://stage.storage.specteam.pl/v5/",
                databaseName: "Specteam",
                ordersSystemUrl: "https://stage.shop.specteam.pl/#order/{id}"
            },
            [Env.Prod]: {
                storageUrl: "https://storage.specteam.pl/v5/",
                databaseName: "Specteam",
                ordersSystemUrl: "https://shop.specteam.pl/#order/{id}"
            }
        };
        
    constructor(private _env: EnvDetector)
    { }

    public get OrdersSystemUrl(): string
    {
        return this.CONFIG[this._env.Env].ordersSystemUrl;
    }

    public GetOrderUrl(orderId: string): string
    {
        return this.OrdersSystemUrl.replace("{id}", orderId);
    }

    public get StorageUrl(): string
    {
        return this.CONFIG[this._env.Env].storageUrl;
    }

    public get DatabaseName(): string
    {
        return this.CONFIG[this._env.Env].databaseName;
    }
}
